<template>
  <InvestorOnboardingStep>
    <View direction="column" gap="lg">
      <Text variant="h2">How strict should screening be?</Text>

      <ScreeningSensitivityCards v-model="model" :disabled="isSaving" />

      <View justify="end" gap="sm">
        <Button variant="ghost" :disabled="isSaving" @click="goBack">Back</Button>
        <Button :disabled="!canContinue" :loading="isSaving" @click="next">Continue</Button>
      </View>
    </View>
  </InvestorOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { Button, Text, View } from '@tallo/design-system';
import {
  InvestorOnboardingStep as OnboardingStep,
  useOnboardingStep,
  useOnboardingStore,
} from '@tallo/investor/investor';
import { AppRouteNames } from '@tallo/investor/navigation';
import { ScreeningSensitivityCards } from '@tallo/property';

import InvestorOnboardingStep from '../components/investor-onboarding-step.vue';

const store = useOnboardingStore();
const router = useRouter();

// Local until saved: the store only ever holds what the server has
const model = ref(store.screeningSensitivity);
const { goBack, isSaving, canContinue, save, onContinue } = useOnboardingStep(() => !!model.value);

async function next() {
  const screeningSensitivity = model.value;
  if (!screeningSensitivity) return;

  await save(async () => {
    await store.saveStep(OnboardingStep.RentalStrategy, { screeningSensitivity });
    router.push({ name: AppRouteNames.INVESTOR_ONBOARDING_CONNECT_CALENDAR });
  }, "We couldn't save your screening preference. Please try again.");
}

onContinue(next);
</script>
